import { FC } from 'react';

import { Box, useTheme } from '@mui/material';
import { useBrightTheme } from 'hooks';
import { AccentColorType, getAccentColor } from 'portfolio3/styles';
import { SxStyles } from 'types';
import { isDefined, mergeSx } from 'utils';

import * as styles from './styles';

interface ITimelineProps {
  withDot?: boolean;
  year?: number;
  sx?: SxStyles;
  yearSx?: SxStyles;
  dotSx?: SxStyles;
}

const Timeline: FC<ITimelineProps> = ({ withDot, year, sx, yearSx, dotSx }) => {
  const isBrightTheme = useBrightTheme();
  const theme = useTheme();

  const accentColorType: AccentColorType = isBrightTheme ? theme.palette.accentColor : 'indigo';
  const dotColor = getAccentColor(accentColorType, '48');

  return (
    <Box className="timeline" sx={mergeSx(styles.root, sx)}>
      <Box sx={styles.line} />
      {withDot && (
        <Box sx={mergeSx(styles.dot, { backgroundColor: dotColor }, dotSx)}>
          <Box sx={styles.innerDot} />
        </Box>
      )}
      {isDefined(year) && <Box sx={mergeSx(styles.year, yearSx)}>{year}</Box>}
    </Box>
  );
};

export default Timeline;
